import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

import type { CardId } from '@vlabs/api/point-api/model';

export const generateLink = (cardId: CardId) => generatePath(routes.externalId.read, { externalId: cardId });
